import { render, staticRenderFns } from "./CustomerEmailAddressInfo.vue?vue&type=template&id=7950ab22&scoped=true"
import script from "./CustomerEmailAddressInfo.vue?vue&type=script&lang=js"
export * from "./CustomerEmailAddressInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7950ab22",
  null
  
)

export default component.exports